import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';

@Component({
  selector: 'app-outsource-view',
  templateUrl: './outsource-view.component.html',
  styleUrls: ['./outsource-view.component.scss', '../../../../../../assets/sass/pages/page-users.scss']
})
export class OutsourceViewComponent implements OnInit {

  outsource_Id: any
  outsource_data :any
  constructor(private apiService: ApiService,
    private activatedroute: ActivatedRoute,
    private session: SessionStorageService,
    private route: Router) {
    this.activatedroute.paramMap.subscribe(params => {
      this.outsource_Id = params.get('id');
    });
  }

  ngOnInit(): void {
    this.getLeadById()
  }
  getLeadById() {
    this.apiService.getOutsourceLeadsById(this.outsource_Id).subscribe((res: any) => {
      if(res.statusCode === 200){
        for(let item of res?.data){
          this.outsource_data=item
        }
      }
    })
  }
}
